export const IGNORE_PATTERNS: RegExp[] = [
	/collector\.solarwinds/i,
	/runtime\.lastError/i,
	/\bstatus(?:\s+code)?[:\s"]+40[13]\b/i,
	/\b40[13]\s+(?:unauthorized|forbidden)\b/i,
	/Could not establish connection\. Receiving end does not exist/i,
	/The message port closed before a response was received/i,
	/Attempting to use a disconnected port object/i,
	/Extension context invalidated/i,
	/back\/forward cache, so the message channel is closed/i,
	/No tab with id:/i,
	/Opening tag\s+"?[^"\s]+"?\s+not terminated/i,
	/Failed to attach debugger.*restricted URL/i
];

export const OBJECT_OBJECT = '[object Object]';
export const REBUILT_MESSAGE_MAX_LENGTH = 500;
